import React from 'react';
import DropdownMenu from './DropdownMenu';
import ConversationFilterItem from './ConversationFilterItem';

const ConversationFilter = ({
  onChange, dropdownMenu, selectedOption, ...rest
}) => {
  return (
    <DropdownMenu {...rest}>
      {/* eslint react/no-array-index-key: "off" */
        dropdownMenu.map((item, index) => {
          return (
            <ConversationFilterItem
              label={item.label}
              key={index}
              value={item.value}
              onClick={onChange}
              type="BUTTON"
              className="report_issue"
              iconclassName="flag"
              selectedOption={selectedOption}
            />
          );
        })}
    </DropdownMenu>
  );
};

export default ConversationFilter;
